import { render, staticRenderFns } from "./JobDescription.vue?vue&type=template&id=f8cdb69c&scoped=true&"
import script from "./JobDescription.vue?vue&type=script&lang=js&"
export * from "./JobDescription.vue?vue&type=script&lang=js&"
import style0 from "./JobDescription.vue?vue&type=style&index=0&id=f8cdb69c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cdb69c",
  null
  
)

export default component.exports